import Image from 'next/image';
import DallasImageProps from '../dallas-image-props';
import ShootingStarSvg from './shooting-star-black-white.svg';

export default function DallasImageShootingStar(props: DallasImageProps) {
  return <Image src={ShootingStarSvg} alt="Shooting star" {...props} />;
}
